import React, { Component } from 'react';
import { Modal, Steps, Button, message, Select, DatePicker, TimePicker } from 'antd';
import VisitorModal from './VisitorModal';
import axios from 'axios';
import Configuration from '../../Configuration';
import moment from 'moment';
const Step = Steps.Step;
const Option = Select.Option;

class VisitVisitorModal extends Component {
  constructor(props) {
    super(props);
    this.schema = {name: ''};
    this.headers = {Authorization: localStorage.getItem('visitapp:token')};
    this.steps = {step0: {profile_id: false, transport_id: false}, step1: {visitors: false, subject: false}, step2: {due_date: false, time: false}, step3: {details: true}};
    this.state = {step: 0, stepLimit: 3, stepValidation: this.steps, visitVisitor: {}, visitors: [], transports: [], employees: [], visitCompanies: [], modalVisible: false, rol: localStorage.getItem('visitapp:rol')};
    // Modal functions
    this.handleNext = this.handleNext.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.showStep = this.showStep.bind(this);
    this.getVisitors = this.getVisitors.bind(this);
    this.getTransports = this.getTransports.bind(this);
    this.getEmployees = this.getEmployees.bind(this);
    // Input values
    this.handleSubject = this.handleSubject.bind(this);
    this.handleVisitors = this.handleVisitors.bind(this);
    this.handleTransports = this.handleTransports.bind(this);
    this.handleEmployees = this.handleEmployees.bind(this);
    this.handleDueDate = this.handleDueDate.bind(this);
    this.handleTime = this.handleTime.bind(this);
    this.handleDetails = this.handleDetails.bind(this);
    this.setProp = this.setProp.bind(this);
    // New visitor
    this.getVisitCompanies = this.getVisitCompanies.bind(this);
    this.handleCreateVisitor = this.handleCreateVisitor.bind(this);
    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
  }

  componentDidMount() {
    // Set props for employee
    if (Configuration.isInRol(this.state.rol, "empleado")) {
      this.setProp('profile_id', localStorage.getItem('visitapp:id'));
      this.setProp('profile_name', localStorage.getItem('visitapp:names'));
    }

    this.getVisitors();
    this.getTransports();
    this.getEmployees();
    this.getVisitCompanies();
  }

  handleNext() {
    if(!this.validateStep())
      return message.warning('Necesitas llenar los campos obligatorios'); 
  
    if(this.state.step === this.state.stepLimit) {
      this.props.handleSave(this.state.visitVisitor);
      this.setState({visitVisitor: {}, step: 0, stepValidation: this.steps});
    } else {
      let steps = 1;
      // Autocomplete date inputs
      if(this.state.step === 1 && this.props.hideDate) {
        this.handleDueDate(moment());
        this.handleTime(moment());
        steps = 2;
      }

      this.setState({step: this.state.step + steps});
    }
  }

  handleBack() {
    if(this.state.step === 0) {
      this.props.handleClose('visitorVisible');
    } else {
      this.setState({step: this.state.step - 1});
    }
  }

  validateStep() {
    let steps = 0;
    let total = 0;
    for(let item in this.state.stepValidation[`step${this.state.step}`]) {
      if(this.state.stepValidation[`step${this.state.step}`][item]) {
        steps += 1;
      }
      total += 1;
    }
    
    if(steps === total) {
      return true;
    } else {
      return false;
    }
  }

  getVisitors() {
    let url = `${Configuration.apiServer}/api/v1/visitors`;
    if(localStorage.getItem('visitapp:rol').toLowerCase() === 'guardia')
      url = `${Configuration.apiServer}/api/v1/access-visitors`;

    axios.get(url, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida')
      
      this.setState({visitors: resp.data});
    });
  }

  getEmployees() {
    axios.get(`${Configuration.apiServer}/api/v1/access-profiles`, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida')

      this.setState({employees: resp.data});
    });
  }

  getTransports() {
    axios.get(`${Configuration.apiServer}/api/v1/transports`, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida')

      this.setState({transports: resp.data});
    });
  }

  getVisitCompanies() {
    axios.get(`${Configuration.apiServer}/api/v1/visit_companies`, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida')
      
      this.setState({visitCompanies: resp.data});
    });
  }

  handleOpenModal() {
    this.setState({modalVisible: true});
  }

  handleCloseModal() {
    this.setState({modalVisible: false});
  }

  handleCreateVisitor(record) {
    axios.post(`${Configuration.apiServer}/api/v1/visitors`, {visitor: record}, {headers: this.headers}).then(resp => {
      console.log(resp.data);
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida')

      this.getVisitors();
      this.setState({modalVisible: false});
      message.success('Registro guardado');
    });
  }

  handleSubject(event) {
    this.setProp('subject', event.target.value);
  }

  handleVisitors(value) {
    this.setProp('visitors', value);
  }

  handleEmployees(value) {
    const employee = value.split('-');
    this.setProp('profile_id', employee[0]);
    this.setProp('profile_name', employee[1]);
  }
  
  handleTransports(value) {
    this.setProp('transport_id', value);
  }

  handleDueDate(value) {
    this.setProp('due_date', value.format('YYYY-MM-DD'));
  }

  handleTime(value) {
    this.setProp('time', value.format('HH:mm:ss'));
  }

  handleDetails(event) {
    this.setProp('details', event.target.value);
  }

  setProp(prop, value) {
    const record = this.state.visitVisitor;
    let validation = this.state.stepValidation;
    record[prop] = value;
    
    // Update validation
    if(String(value).length > 0) {
      validation[`step${this.state.step}`][prop] = true;
    } else {
      validation[`step${this.state.step}`][prop] = false;
    }

    this.setState({visitVisitor: record, stepValidation: validation});
  }

  showStep(step) {
    if(step === this.state.step) {
      return 'block';
    } else {
      return 'none';
    }
  }

  render() {
    // Options for visitors select
    const visitorOptions = this.state.visitors.map(visitor => {
      return (
        <Option value={visitor.id} className="text-capitalize" key={`visitor:${visitor.id}`}>{visitor.name}</Option>
      );
    });
    // Options for transports select
    const transportOptions = this.state.transports.map(transport => {
      return (
        <Option value={transport.id} className="text-capitalize" key={`transport:${transport.id}`}>{transport.name}</Option>
      );
    });
    // Options for employees select
    const employeeOptions = this.state.employees.map(employee => {
      return (
        <Option value={`${employee.id}-${employee.names}`} className="text-capitalize" key={`employee:${employee.id}`}>{employee.names}</Option>
      );
    });

    // Render component
    return (
      <div>

        <Modal
          title="Visita de persona externa"
          visible={this.props.visible}
          onCancel={() => { this.props.handleClose('visitorVisible') }}
          width={900}
          footer={null}
          destroyOnClose={true}
        >
          <div className="row" style={{ padding: '0px 30px' }}>
            <Steps size="small" current={this.state.step}>
              <Step title="Transporte" />
              <Step title="Asunto" />
              <Step title="Fecha" />
              <Step title="Detalles" />
            </Steps>
          </div>

          <br/> <br/>

          <div className="row" style={{ padding: '0px 30px' }}>
            <div style={{ width: '100%', display: this.showStep(0) }}>
              <div className="form-group">
                <label>Tipo de transporte</label>
                <Select
                  showSearch
                  style={{ width: '100%' }}
                  placeholder="Elige un transporte"
                  optionFilterProp="children"
                  onChange={this.handleTransports}
                  filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                >
                  {transportOptions}
                </Select>
              </div>

              {!Configuration.isInRol(this.state.rol, "empleado") ? 
                <div className="form-group">
                  <label>¿A quién visita?</label>
                  <Select
                    showSearch
                    style={{ width: '100%' }}
                    placeholder="Elige un empleado"
                    optionFilterProp="children"
                    onChange={this.handleEmployees}
                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                  >
                    {employeeOptions}
                  </Select>
                </div>
                : null
              }
            </div>

            <div style={{ width: '100%', display: this.showStep(1) }}>
              <div className="form-group">
                <label>Asunto de la visita</label>
                <input type="text" className="form-control" placeholder="Escribe el proposito de la visita" onChange={this.handleSubject} />
              </div>

              <div className="form-group">
                <label>Visitante</label>
                <div className="d-flex justify-content-between align-items-center">
                  <Select
                    showSearch
                    mode="multiple"
                    style={{ width: '90%' }}
                    placeholder="Elige una persona"
                    optionFilterProp="children"
                    onChange={this.handleVisitors}
                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                  >
                    {visitorOptions}
                  </Select>
                  <Button icon="plus" type="primary" shape="circle" onClick={this.handleOpenModal} />
                </div>
              </div>
            </div>
            
            <div style={{ width: '100%', display: this.showStep(2) }}>
              <div className="form-group">
                <label>¿Qué día es la visita?</label>
                <br />
                <DatePicker onChange={this.handleDueDate} style={{ width: '100%' }} />
              </div>
              <div className="form-group">
                <label>¿A qué hora llega la visita?</label>
                <br />
                <TimePicker onChange={this.handleTime} style={{ width: '100%' }}  />
              </div>
            </div>

            <div style={{ width: '100%', display: this.showStep(3) }}>
              <div className="form-group">
                <label>Detalles (Opcional)</label>
                <input type="text" className="form-control" placeholder="Escribe algunos detalles sobre la visita" onChange={this.handleDetails} />
              </div>
            </div>
          </div>

          <br/><hr/>

          <div className="form-group text-center">
            <Button type="dashed" style={{ marginRight: '10px' }} onClick={this.handleBack}>Atras</Button>
            <Button type="primary" onClick={this.handleNext}>Siguiente</Button>
          </div>
        </Modal>

        <VisitorModal visible={this.state.modalVisible} title={"Nuevo visitante"} companies={this.state.visitCompanies} current={this.schema} handleClose={this.handleCloseModal} handleSave={this.handleCreateVisitor} />
      </div>
    );
  }
}

export default VisitVisitorModal;



// WEBPACK FOOTER //
// ./src/components/modals/VisitVisitorModal.js